<p-dialog [header]="dialogTitle" [(visible)]="showDialog" [modal]="true" [resizable]="false" [draggable]="false" [width]="680"
  styleClass="period-dialog" (onHide)="cancel()">
  <form *ngIf="periodForm" [formGroup]="periodForm" (ngSubmit)="save()">
    <div class="ui-g ui-fluid period-grid">
      <div class="ui-g-12 ui-md-6 field">
        <label>{{ 'storeConfigurationList.date_start' | translate }} <span class="req">*</span></label>
        <p-calendar [appendTo]="'body'" formControlName="date_start" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
          yearRange="1900:2999" showButtonBar="true" [showIcon]="true" placeholder="GG/MM/AAAA"
          [defaultDate]="periodForm.get('date_start').value"></p-calendar>
      </div>
      <div class="ui-g-12 ui-md-6 field">
        <label>{{ 'storeConfigurationList.date_end' | translate }} <span class="req">*</span></label>
        <p-calendar [appendTo]="'body'" formControlName="date_end" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
          yearRange="1900:2999" showButtonBar="true" [showIcon]="true" placeholder="GG/MM/AAAA"
          [defaultDate]="periodForm.get('date_end').value"></p-calendar>
      </div>

      <div class="ui-g-12 info-row">
        <i class="fa fa-info-circle"></i>
        <span>Il periodo non deve sovrapporsi ad altri periodi già definiti per questo Ambito.</span>
      </div>

      <div class="ui-g-12">
        <h3 class="modules-title">{{ 'storeConfigurationList.modules' | translate }}</h3>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'storeConfigurationList.front_end' | translate }} (Touch point)</label>
        <p-dropdown [appendTo]="'body'" [options]="listFrontEndType" [filter]="true" formControlName="front_end_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'storeConfigurationList.promotion' | translate }}</label>
        <p-dropdown [appendTo]="'body'" [options]="listPromotionType" [filter]="true" formControlName="promotion_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'storeConfigurationList.customer_system' | translate }}</label>
        <p-dropdown [appendTo]="'body'" [options]="listCustomerType" [filter]="true" formControlName="customer_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'storeConfigurationList.loyalty_system' | translate }}</label>
        <p-dropdown [appendTo]="'body'" [options]="listLoyaltyType" [filter]="true" formControlName="loyalty_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'storeConfigurationList.analytics_system' | translate }}</label>
        <p-dropdown [appendTo]="'body'" [options]="listAnalyticType" [filter]="true" formControlName="analytics_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'storeConfigurationList.backoffice_system' | translate }}</label>
        <p-dropdown [appendTo]="'body'" [options]="listBackOfficeType" [filter]="true" formControlName="backoffice_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'storeConfigurationList.couponing_system' | translate }}</label>
        <p-dropdown [appendTo]="'body'" [options]="listCouponingType" [filter]="true" formControlName="couponing_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 ui-sm-6 ui-md-3 field">
        <label>{{ 'campaign.touchpoint' | translate }}</label>
        <p-dropdown [appendTo]="'body'" [options]="listChannel" [filter]="true" formControlName="ochannel_id"
          placeholder="— Nessuno —" [showClear]="true" [autoDisplayFirst]="false"></p-dropdown>
      </div>

      <div class="ui-g-12 overlap-error" *ngIf="overlapError">
        <i class="fa fa-exclamation-triangle"></i>
        <span>Il periodo si sovrappone ad un periodo già esistente per questo Ambito.</span>
      </div>
    </div>

    <div class="dialog-footer">
      <button type="button" pButton label="{{ 'common.cancel' | translate }}" class="btn-cancel" (click)="cancel()"></button>
      <button type="submit" pButton label="{{ 'common.save' | translate }}" icon="fa fa-check" class="btn-save"></button>
    </div>
  </form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/store-configuration/store-configuration-period-form.html